import { useCallback } from 'react';

import { useSetPasswordMutation } from './__generated__/setPassword.generated';
import { PasswordSet } from '../components/PasswordSet';
import { RootStackScreenProps } from '../../../app/UnauthenticatedApp/types';

type Props = RootStackScreenProps<'ResetPassword'>;

export const ResetPassword = ({
	route: {
		params: { code },
	},
}: Props) => {
	const [setPassword, { loading }] = useSetPasswordMutation();

	const handlePasswordChange = useCallback(
		(newPassword: string) => {
			if (loading) {
				return;
			}

			return setPassword({
				variables: {
					code,
					password: newPassword,
				},
			});
		},
		[code, loading, setPassword],
	);

	return <PasswordSet onSubmitPassword={handlePasswordChange} />;
};
